// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"e941c8ba","453":"18216636","573":"adcda926","826":"97801f39","875":"a02e601b"}[chunkId] + ".chunk.js";
};